import { IPredictedLineupsHp } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpPredictedLineups } from './typeguards';
import { CreateLmpPredictedLineupDetailsInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpPredictedLineupsQuery } from '../types';
import { transformPlayerList, transformTeam } from '../../../utils/formation/formation';
import { IGenericObject } from '../../../utils/tests';

export default (obj: LmpPredictedLineupsQuery): IPredictedLineupsHp => {
  if (isValidLmpPredictedLineups(obj)) {
    CreateLmpPredictedLineupDetailsInputSchema().parse(obj.data.predictedLineupLmp, {reportInput: true});

    const { away, date, home, matchId, round, status } = obj.data.predictedLineupLmp;
      const awayAliases = transformTeam(away!);
      const homeAliases = transformTeam(home!);

      const match: IGenericObject = {
        date,
        matchId,
        status,
        away: {
          ...awayAliases,
          playerList: transformPlayerList(awayAliases.playerList ?? [], 'LMP'),
        },
        home: {
          ...homeAliases,
          playerList: transformPlayerList(homeAliases.playerList ?? [], 'LMP'),
        },
      };

      return {
        variant: 'LMP',
        round,
        matchList: [match],
      } as IPredictedLineupsHp;

  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpPredictedLineupsQuery object',
      data: obj
    });
  }
};
